export const LightningBoltSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 9.88615C4 9.74288 4.06151 9.59006 4.18453 9.42768L10.6359 1.29693C10.7542 1.14411 10.8819 1.05098 11.0192 1.01755C11.1611 0.984121 11.2865 0.998448 11.3953 1.06053C11.5089 1.11784 11.5869 1.21336 11.6295 1.34708C11.6768 1.4808 11.665 1.6384 11.594 1.81988L9.47906 7.62244H13.489C13.6404 7.62244 13.7634 7.6702 13.8581 7.76571C13.9527 7.85645 14 7.97107 14 8.10957C14 8.25762 13.9385 8.41044 13.8155 8.56804L7.36409 16.7059C7.2458 16.854 7.11568 16.9447 6.97374 16.9782C6.83653 17.0164 6.71114 17.0044 6.59759 16.9424C6.48876 16.885 6.41069 16.7895 6.36338 16.6558C6.32079 16.5221 6.33499 16.3621 6.40596 16.1758L8.52094 10.3733H4.511C4.35959 10.3733 4.23657 10.3279 4.14194 10.2372C4.04731 10.1417 4 10.0247 4 9.88615Z" />
    </svg>
  );
};
